<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--setting"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addPermissionModal.${"title"}`) }}</div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <div class="add__content">
              <div class="form__field">
                <input type="text" class="input input--default" :class="{ 'input--error': permissionNameHasError }"
                  :placeholder="$t(`addPermissionModal.${'permissionPlaceholder'}`)" v-model="permissionName" />
                <div class="form__error" v-if="permissionNameHasError">
                  {{ $t(`addPermissionModal.${"permissionErrorMsg"}`) }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else>
        <button v-if="canCreatePermission"
          class="modal__button modal__button--submit button button--default" @click="addPermission()">
          <span>{{ $t(`addPermissionModal.${"saveBtn"}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

defineOptions({
  name: "AddPermissionModal"
});

const store = useStore();
const route = useRoute();
const teamId = computed(() => {
  const value = Number(route.query.team_id);
  return Number.isInteger(value) && value > 0 ? value : null;
});
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canCreatePermission = computed(() => {
  if (isSuperAdmin.value) return true;
  return teamId.value !== null && store.getters.hasTeamPermission("permission_create", teamId.value);
});

// Reactive State
const permissionName = ref("");
const permissionNameHasError = ref(false);
const isRequesting = ref(false);

// Watchers
watch(permissionName, (value) => {
  permissionNameHasError.value = !value;
});

// Methods
const closeModal = () => {
  store.commit("setShowAddPermissionModal", false);
};

const addPermission = async () => {
  isRequesting.value = true;
  try {
    if (permissionName.value && canCreatePermission.value) {
      await store.dispatch("createPermission", { title: permissionName.value, teamId: teamId.value });
      await store.dispatch("getPermissions", teamId.value);
      closeModal();
    } else {
      permissionNameHasError.value = true;
    }
  } catch (_) {
    // The store keeps the modal open and displays the backend error.
  } finally {
    isRequesting.value = false;
  }
};

// Lifecycle Hooks
onMounted(() => {
  if (!canCreatePermission.value) {
    closeModal();
  }
});
</script>
<style scoped lang="scss">
.form__field {
  margin-top: 160px;
}

.modal__button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 200px;
}
</style>
